var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-0 pa-5 marginBottom",attrs:{"flat":""}},[_c('h1',{staticClass:"fonte text-uppercase"},[_vm._v("Agendar uma Campanha")]),_vm._v(" "),_c('v-layout',{staticClass:"pa-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pb-2":""}},[_c('Calendario')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8610a0f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/mensagens/Campanhas.vue
// module id = 917
// module chunks = 0